import { Navigate } from 'react-router';
import { useAuth } from '../contexts/AuthContext';

// Hierarquia de papéis: nível numérico para comparação ≥
const ROLE_LEVEL = { admin: 4, manager: 3, esn: 2, apn: 1 };

// requiredRole: mínimo exigido — papéis com nível >= têm acesso
// requiredFunnel: 'new_names' | 'base' — ESNs com acesso limitado
export default function ProtectedRoute({ children, requiredRole, requiredFunnel }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;

  if (user.must_change_password) {
    return <Navigate to="/perfil?force=true" replace />;
  }

  const role = user.role;
  const funnelAccess = user.funnel_access || 'both';

  if (requiredRole) {
    const userLevel = ROLE_LEVEL[role] ?? 0;
    const minLevel  = ROLE_LEVEL[requiredRole] ?? 99;
    if (userLevel < minLevel) return <Navigate to="/dashboard" replace />;
  }

  if (requiredFunnel && role === 'esn') {
    const allowed = funnelAccess === 'both' || funnelAccess === requiredFunnel;
    if (!allowed) return <Navigate to="/dashboard" replace />;
  }

  return children;
}
